import { Routes } from '@angular/router';


export const routes: Routes = [
  {
    path: '', children: [
      {
        path: '', loadComponent: () => import('./mobile-app-development.component').then(m => m.MobileAppDevelopmentComponent),
        data: {
          title: 'KudosHub | Mobile App Development',
          description:'Elevate your employee productivity, key operations and business security with our attractive mobile app development services.',
          keywords: 'mobile aap, development',
          ogTitle: 'KudosHub | Mobile App Development',
          ogDesc: 'Elevate your employee productivity, key operations and business security with our attractive mobile app development services.',
          ogImage: 'https://kudoshub.com/theme/images/og-images/mobile-applications2.webp',
          ogUrl: 'https://kudoshub.com/mobile-app-development',
          twitterTitle: 'KudosHub | Mobile App Development',
          twitterDesc: 'Elevate your employee productivity, key operations and business security with our attractive mobile app development services.',
          twitterImage: 'https://kudoshub.com/theme/images/og-images/mobile-applications2.webp'
        }
      }
    ]
  }
];
